export default __webpack_public_path__ + "static/media/gift.e4643db1.svg";